import { render, staticRenderFns } from "./myCertificate.vue?vue&type=template&id=e98fd6ee&scoped=true"
import script from "./myCertificate.vue?vue&type=script&lang=js"
export * from "./myCertificate.vue?vue&type=script&lang=js"
import style0 from "./myCertificate.vue?vue&type=style&index=0&id=e98fd6ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e98fd6ee",
  null
  
)

export default component.exports